exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-af875844] {\n  padding: 0 16px;\n  margin: 48px 0 24px;\n  text-align: center;\n}\n.footer .links[data-v-af875844] {\n  margin-bottom: 8px;\n}\n.footer .links a[data-v-af875844] {\n  color: rgba(0, 0, 0, 0.45);\n}\n.footer .links a[data-v-af875844]:hover {\n  color: rgba(0, 0, 0, 0.65);\n}\n.footer .links a[data-v-af875844]:not(:last-child) {\n  margin-right: 40px;\n}\n.footer .copyright[data-v-af875844] {\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n}\n", ""]);

// exports
